import { BaseHttpService, CmsApi, ConfiguratorApi, createNetworkAwareService, PlatformApi } from "@pandas/http-client";
import { servicesOrchestratorValues } from "@/config/services";
import logger from "@/utils/logging/logger";

const { urls } = servicesOrchestratorValues;

export type RetailApiClient = {
	platform: PlatformApi;
	configurator: ConfiguratorApi;
	cms: CmsApi;
};

export function createRetailApiClient(): RetailApiClient {
	function makeHttp(baseUrl: string) {
		return createNetworkAwareService(new BaseHttpService(baseUrl, logger));
	}

	const platform = new PlatformApi(makeHttp(`${urls.platform}/api/v1`));
	const configurator = new ConfiguratorApi(makeHttp(`${urls.platform}/api/v2`), "partner-base");
	const cms = new CmsApi(makeHttp(urls.cms));

	return { platform, configurator, cms };
}
